var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHaeting(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160mm",
    height: "160mm",
    viewBox: "0 0 160 160",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.651 117.5 64.952-37.5 64.952 37.5-64.952 37.5z",
    fill: "#fc9",
    stroke: "#ff8000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.651 117.5v-75l64.952-37.5v75z",
    fill: "#9df",
    stroke: "#00f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.603 5 64.952 37.5v75l-64.952-37.5z",
    fill: "#9df",
    stroke: "#00f"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#ff8000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m116.91 52.5c5.3034 2.5 10.115 10.232 0 15-5.1935 2.4482-5.3035 12.5 0 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.612 47.5c-6.3642 2.5-12.138 10.232 0 15 6.2322 2.4482 6.3642 12.5 0 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.56 70c-4.3301 2.5-8.2589 10.232 0 15 4.2403 2.4482 4.3301 12.5 0 15"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m82.272 82.5 60.622 35-56.292 32.5-56.292-32.5 47.631-27.5 47.631 27.5-38.971 22.5-38.971-22.5 30.311-17.5 30.311 17.5-21.651 12.5-21.651-12.5 12.99-7.5 12.99 7.5-8.6602 5 4.3301 2.5 12.99-7.5-21.651-12.5-21.651 12.5 30.311 17.5 30.311-17.5-38.971-22.5-38.971 22.5 47.631 27.5 47.631-27.5-56.292-32.5",
    stroke: "#ff0100",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#ff8000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m95.263 45c-2.9383 2.5-5.6043 10.232 0 15 2.8774 2.4482 2.9383 12.5 0 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.641 70c-2.9383 2.5-5.6043 10.232 0 15 2.8774 2.4482 2.9383 12.5 0 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.292 57.5c2.426 2.5 4.6272 10.232 0 15-2.3757 2.4482-2.426 12.5 0 15"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaeting);
export default __webpack_public_path__ + "static/media/haeting.676b57983f4d5ef1b05bebbe9b0d928c.svg";
export { ForwardRef as ReactComponent };